function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.72 13.063h-6.958v-1.956h8.915v30.788h-8.915v-1.956h6.959V13.063zM8.701 0l21.826 7.758V42H15.524V25.8H8.7V0zm1.883 2.736v21.782h5.473v15.525h12.587V9.156l-18.06-6.42z",
  fill: "#4CAF50"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.418 25.96H1.886v14.084h12.532V25.96zM0 24.004V42h16.305V24.004H0z",
  fill: "#4CAF50"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.81.041h1.957V5.62H21.81V.04zM3.635 31.652v-2.834h2.834v2.834H3.635zM3.635 37.658v-2.834h2.834v2.834H3.635zM9.74 37.658v-2.834h2.835v2.834H9.74zM9.74 31.652v-2.834h2.835v2.834H9.74zM12.813 14.584V11.87h2.78v2.714h-2.78zM12.813 20.672v-2.714h2.78v2.714h-2.78zM18.451 14.584V11.87h2.78v2.714h-2.78zM18.451 20.672v-2.714h2.78v2.714h-2.78zM23.951 14.584V11.87h2.78v2.714h-2.78zM23.951 20.672v-2.714h2.78v2.714h-2.78zM23.951 26.76v-2.715h2.78v2.715h-2.78zM18.453 26.76v-2.715h2.78v2.715h-2.78zM19.844 40.93v-9.85h5.048v9.85h-5.048zM25.754.041h1.956v7.232h-1.956V.041zM3.01 19.215h1.956v6.037H3.01v-6.037zM32.762 15.365h4.275v1.956h-4.275v-1.956zM32.762 20.3h4.275v1.957h-4.275V20.3zM32.762 25.236h4.275v1.956h-4.275v-1.956zM32.762 30.172h4.275v1.956h-4.275v-1.956zM32.762 35.11h4.275v1.955h-4.275V35.11z",
  fill: "#4CAF50"
});

function SvgCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCity;